import { Component, inject, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BomDetailsComponent,
  BomDetailsDialogData,
} from '../../../../shared/dialog/bom-details/bom-details.component';
import { BomDetailsExtraDataDirective, BomDetailsTitleDirective } from '../../../../shared/dialog/bom-details/bom-details.directive';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ApiRouteInspectionAssemblyItemService } from '../../../../api/elite/routes/inspection-assembly-item.service';

export type HosesBomDetailsDialogData = BomDetailsDialogData & {
  itemName: string;
};

@Component({
  standalone: true,
  imports: [
    CommonModule,
    BomDetailsComponent,
    MatProgressBarModule,
    BomDetailsTitleDirective,
    BomDetailsExtraDataDirective,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
  ],
  templateUrl: './bom-details.component.html',
  styleUrls: ['./bom-details.component.sass'],
})
export class HosesBomDetailsComponent implements OnInit {
  private readonly apiInspectionRouter = inject(
    ApiRouteInspectionAssemblyItemService
  );
  loading = true;
  url: string;
  destinationName?: string;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: HosesBomDetailsDialogData
  ) {}

  ngOnInit(): void {
    this.apiInspectionRouter.getMeasureByName(this.data.itemName, this.data.searching).subscribe({
      next: (info) => {
        if (info) {
          this.url = info.urlDrive;

          const dests = info.assemblyItem?.hosesDestination;
          if (dests && dests.length > 0) {

            const hasMultiple = dests.length > 1;

            this.destinationName = dests.map(d => {
              if (hasMultiple && d.quantity) {
                return `${d.destination.destinationName} (Cant: ${d.quantity})`;
              }
              return d.destination.destinationName;
            }).join(' | ');
          }
        }

        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      }
    });
  }
}
